import React from "react";
import { TextField } from "@mui/material";
import { colors } from "../../Config/Colors";

export default function Input(props) {
  const {
    name,
    label,
    value,
    error = null,
    onChange,
    disabled = false,
  } = props;

  return (
    <TextField
      className="w-full"
      disabled={disabled}
      variant="outlined"
      label={label}
      name={name}
      value={value || ""}
      onChange={onChange}
      {...(error && { error: true, helperText: error })}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "12px",
          backgroundColor: "#f9fafb",
          fontSize: "15px",
          "& fieldset": {
            borderColor: "#e5e7eb",
            borderWidth: "1px",
          },
          "&:hover fieldset": {
            borderColor: "#d1d5db",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#6366f1",
            borderWidth: "2px",
          },
        },
        "& .MuiInputLabel-root": {
          color: "#6b7280",
          fontSize: "14px",
        },
        "& .MuiInputLabel-shrink": {
          backgroundColor: "#f9fafb",
        },
        "& input": {
          padding: "12px 14px",
        },
      }}
    />
  );
}
